import React, { useContext, useEffect, useState } from 'react';
import Icons from "../Icons/index";
import { Context } from "../contexts/AppContext";
import { getData, postData, putData } from '../../lib/utils';
import PostcodeLookup from './PostcodeLookup';
import Uploadvideo from '../Gallery/UploadVideo';

const VideoHeader = () => {
 
const { progress, value } = useContext(Context);
const [appState, setAppState] = value; 

   
 

const {currentFolderName, currentGalleryName, currentGalleryId,currentDBGalleryId,}=appState;
const { startProgress, updateProgress, stopProgress  } = progress;
const [uploadedBytesTracker, setUploadedBytesTracker] = useState(0);
const ONE_GB = 1000; // 1000GB
//console.log('video header ',appState)
window.onload = async()=> {
  //console.log("WINDOW---------")
  const url = window.location.pathname; // Get current URL path
  // Split the URL by '/' and extract the gallery ID
  const parts = url.split('/');
  const galleryId = parts[parts.indexOf('galleries') + 1]; 
  const response = await getData(`galleries/gallery/${galleryId}`);
  if(response)
  {
    console.log("VIDEOHEADER.js call get api of galleries/gallery ",response);
    const obj ={}
    obj.name=response?.folder?.name;
    obj.id=response.folder._id;
    obj.galleries=[response.gallery]
    obj.adminId=response.folder.adminId
    obj.backgroundMedia=response?.gallery?.backgroundMedia
    setAppState((prevState) => {
      return { ...prevState, 
         currentFolderData:obj,
         videoArr:response.videos,
         currentGalleryName:response.gallery.name
                      
      };
    });
  }

} 

     const showProgressBar=(fileName,value)=>{ 
        startProgress(fileName);
        updateProgress(value); 
      } 
      const videoUploadedDone = async (fileName, fileSizeMB, indx, totalVideo,uniqueId, totalFileUploaded) => {
       
        const response = await postData("videos/createVideo", {
          title: fileName.name.split(".")[0],
          url: `${appState.assetsUrl}/${fileName.name}`,
          galleryId: appState.currentGalleryData._id,
        });
      
        if (response) {
          console.log(fileName,"UPLOAD VIDEO DONE HEADER ",fileSizeMB);
      
          setAppState((prevState) => ({
            ...prevState,
            videoArr: [...prevState.videoArr, response],
          }));
      
          stopProgress(uniqueId);
          
      
          // ✅ Calculate new total outside
          const newTotal = Number(uploadedBytesTracker) + Number(fileSizeMB);
          setUploadedBytesTracker(newTotal);
      
       
      
          // ✅ If last video processed
         // if (totalFileUploaded >= totalVideo-1) 
            {

            const creditObj = {
              credits:  newTotal,
              type: "used",
              amount: newTotal,
              purpose: "video upload",
            };
      
            if (appState?.adminDetails?.id) {
              try {
                console.log("now call update plan")
                const res = await putData(`admin/update-plan/${appState.adminDetails.id}`, creditObj);
                
                 /* const creditHistoryObj = {
                    credits:  -(newTotal/1000),
                    type: "used",
                    amount: newTotal,
                    purpose: "video upload",
                  };

                    console.log("newwwwwwwwwww ",newTotal)
                   
                  const resCredit = await postData(`admin/update-credit-history/${appState.adminDetails.id}`, creditHistoryObj);
                  if (resCredit) {
                    console.log("RESCREDIT ---- ", resCredit);
                  }*/
               
      
                // ✅ Reset tracker after successful update
                setUploadedBytesTracker(0);
              } catch (err) {
                console.error("Error updating credit:", err);
              }
            }
          }
        }
      };
      
       

  return (
    <div id="videoHeader" className="border-b border-gray-300 p-4 flex flex-col md:flex-row md:items-center md:justify-between bg-white shadow-sm rounded-md">
    
   
      <h2 className="text-lg font-semibold mb-3 md:mb-0">{appState?.currentFolderData?.name} | {appState?.currentGalleryName}</h2>

      <div className="flex  items-center gap-4">
     {/* <button type="button" className="btn-yellow flex gap-1 justify-center">Gallery Usage</button>*/}
    {/* <button type="button" className="bg-gray-800 text-white px-5 py-2 whitespace-nowrap">Upload Videos</button> */}
      <Uploadvideo showProgressBar={showProgressBar} videoUploadedDone={videoUploadedDone} /> 

       
      </div>
    </div>
  );
};

export default VideoHeader;
